import gql from 'graphql-tag';

export const updateVisitorCustomFieldConfigStatus = gql`
  mutation UpdateVisitorCustomFieldConfigStatus($input: VisitorCustomFieldConfigStatusInput!) {
    updateVisitorCustomFieldConfigStatus(input: $input) {
      id
      organizationId
      fieldKey
      fieldName
      fieldType
      isEnabled
      options {
        displayText
        value
      }
      placeholder
      validationRegex
      createdAtDatetime
      updatedAtDatetime
      createdByUserId
      updatedByUserId
    }
  }
`;
